<div class="changelog">
  <p-dialog
    [(visible)]="isChangelogVisible"
    [modal]="true"
    [blockScroll]="true"
    [style]="{ width: '80vw', height: '80vh' }"
    [draggable]="false"
    (onHide)="resetProperties()">
    <ng-template pTemplate="header">
      <div class="flex gap-2 flex-row items-center w-full p-2">
        <img class="logo" src="./../../../assets/images/logo-header.svg" alt="Login">
        <span class="title">{{ 'changelog.changelog' | transloco }}</span>
      </div>
    </ng-template>
    <ng-template pTemplate="content" class="p-0">
      <div class="changelog-container">
        <div class="sidebar">
          <ul>
            @for (log of changelogData; track log) {
              <li [class.active]="isActive(log.id)">
                <a (click)="scrollTo(log.id)">{{ log.date | date: 'dd.MM.yyyy' }} (v. {{ log.version }})</a>
              </li>
            }

            @if (changelogData.length === 0) {
              <li>{{ 'changelog.noEntries' | transloco }}</li>
            }
          </ul>
        </div>
        <div #scrollContainer class="content">
          @for (log of changelogData; track log) {
            <div [id]="'log-' + log.id" class="log-entry">
              <h2><span>{{ log.date | date: 'dd.MM.yyyy' }}</span> (Version: {{ log.version }})</h2>
              <p>{{ log.description }}</p>
              @if (log.newFeatures.length) {
                <div>
                  <h3>{{ 'changelog.newFeatures' | transloco }}:</h3>
                  <ul>
                    @for (feature of log.newFeatures; track feature) {
                      <li>{{ feature }}</li>
                    }
                  </ul>
                </div>
              }
              @if (log.bugfixes.length) {
                <div>
                  <h3>{{ 'changelog.bugFixes' | transloco }}:</h3>
                  <ul>
                    @for (bug of log.bugfixes; track bug) {
                      <li>{{ bug }}</li>
                    }
                  </ul>
                </div>
              }
              @if (log.technicalChanges.length) {
                <div>
                  <h3>{{ 'changelog.technicalChanges' | transloco }}:</h3>
                  <ul>
                    @for (change of log.technicalChanges; track change) {
                      <li>{{ change }}</li>
                    }
                  </ul>
                </div>
              }
            </div>
          }
          @if (changelogData.length === 0) {
            <p>{{ 'changelog.noEntries' | transloco }}</p>
          }
        </div>
      </div>
    </ng-template>
  </p-dialog>
</div>
